// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Zm-z","tupacHeader":"_m-z","tupacHeader2":"an-z","tupacMenu":"bn-z","tupacMenu2":"cn-z","tupacMain":"dn-z","tupacMain2":"en-z"};